export const getActionVerb = (text: string): string[] => {
  // Splitting on a non-empty separator always yields at least one element, so the
  // default never applies; it only tells the compiler the verb is a string.
  const [actionVerb = '', ...words] = text.split(' ');
  return [actionVerb, words.join(' ')];
};
